import { configureStore } from "@reduxjs/toolkit";
import currentNwsAlertsReducer from "./redux-modules/current-nws-alerts";

const store = configureStore({
  reducer: {
    currentNwsAlerts: currentNwsAlertsReducer,
  },
});

export default store;